import React from 'react';
import { StyledIcon } from 'src/components/foundations/foundations.styles';
import { getFormHelpTextColor } from 'src/components/utils/stylingFunctions';
import { FormState } from 'src/types';
import { useTheme } from 'styled-components';
import { getHelpTextIcon } from './HelpText.helpers';
import {
  HelpTextContent,
  HelpTextSize,
  HelpTextWrapper,
  StyledText,
  StyledTitle,
} from './HelpText.styles';

interface HelpTextProps {
  title?: string;
  helpText: string;
  state: FormState;
  className?: string;
  textSize?: HelpTextSize;
  $margin?: string;
  'data-testid'?: string;
}

export const HelpText: React.FC<HelpTextProps> = ({
  state,
  title,
  helpText,
  className,
  textSize = 'small',
  $margin,
  ...props
}) => {
  const theme = useTheme();
  return (
    <HelpTextWrapper
      data-testid={`${props['data-testid']}`}
      className={className}
      hasTitle={Boolean(title)}
      state={state}
      $margin={$margin ?? ''}
    >
      <StyledIcon
        className={`uil uil-${getHelpTextIcon(state)}`}
        size="24px"
        padding="0 4px 0 0"
        color={getFormHelpTextColor(state, theme)}
      />
      <HelpTextContent hasPadding={Boolean(title)}>
        {title && (
          <StyledTitle state={state} textSize={textSize}>
            {title}
          </StyledTitle>
        )}
        <StyledText state={state} textSize={textSize}>
          {helpText}
        </StyledText>
      </HelpTextContent>
    </HelpTextWrapper>
  );
};
